import loadable from '@loadable/component';
import LoadingComponent from 'components/Loaders/LoadingComponent';

const ReceptacleListLoadable = loadable(() => import('./ReceptacleTypes'), {
  fallback: <LoadingComponent />,
});

export default ReceptacleListLoadable;
